module.exports = reactVendor_9fc61007f131a7cdc627;